const hasDetailedInfo = (address) =>
  Boolean(
    address?.raw ||
      address?.formatted ||
      address?.street_line ||
      address?.route ||
      address?.city ||
      address?.state
  );

export const deriveAddressRecord = (input, readOnly = {}, displayKey) => {
  if (!input) {
    return null;
  }

  if (typeof input === "object") {
    return input;
  }

  const displayAddress = (displayKey && readOnly?.[displayKey]) || readOnly?.address_display;
  const possibleId = typeof input === "object" && input !== null ? input.id : input;

  if (displayAddress) {
    if (!displayAddress.id && possibleId) {
      return { ...displayAddress, id: possibleId };
    }
    if (!possibleId || displayAddress.id === possibleId) {
      return displayAddress;
    }
  }

  if (possibleId && readOnly?.addresses && readOnly.addresses[possibleId]) {
    return { id: possibleId, raw: readOnly.addresses[possibleId] };
  }

  return possibleId ? { id: possibleId } : null;
};

export const mergeAddressRecords = (prev, next) => {
  if (!next) {
    return null;
  }
  if (!prev) {
    return next;
  }

  if (prev.id !== next.id) {
    return next;
  }

  if (hasDetailedInfo(next)) {
    return next;
  }

  return hasDetailedInfo(prev) ? prev : next;
};

export const formatAddressSummary = (address, readOnly = {}) => {
  if (!address) {
    return "No address on file";
  }

  if (address.formatted) {
    return address.formatted;
  }

  if (typeof address === "number" && readOnly?.addresses?.[address]) {
    return readOnly.addresses[address];
  }

  if (address?.id && readOnly?.addresses?.[address.id]) {
    return readOnly.addresses[address.id];
  }

  if (address?.raw) {
    return address.raw;
  }

  const line = [address.street_line || address.route, address.secondary].filter(Boolean).join(" ");
  const cityStateZip = [address.city, address.state, address.post_code].filter(Boolean).join(", ");

  const summary = [line, cityStateZip].filter(Boolean).join(", ");
  if (summary) {
    return summary;
  }

  const fallbackId = address?.id ?? address;
  return fallbackId ? `Address #${fallbackId}` : "No address on file";
};
